import Typography from 'components/Typography/Typography'
import { Container } from 'react-bootstrap'
import { useIntl } from 'react-intl'

export default function TicketsHeader({ isClubMember, isReservation }) {
    const intl = useIntl()
    return (
        <Container fluid className={'tickets--description'}>
            <Typography variant={'label'}>
                {intl.formatMessage({ id: 'orderSummary.ticketsDescription.seat' })}
            </Typography>
            <Typography variant={'label'}>
                {intl.formatMessage({ id: 'orderSummary.ticketsDescription.type' })}
            </Typography>
            <Typography variant={'label'}>
                {intl.formatMessage({ id: 'orderSummary.ticketsDescription.price' })}
            </Typography>
            {isClubMember && !isReservation && (
                <Typography variant={'label'}>
                    {intl.formatMessage({ id: 'orderSummary.ticketsDescription.paymentPoints' })}
                </Typography>
            )}
        </Container>
    )
}
